<template>
  <div class="out-box">
    <!-- <div class="log-header">
      <div class="log-container">
        <div class="brand"><img :src="brand" alt=""></div>
        <div class="log-welcome">欢迎登录</div>
      </div>
    </div>
    <div class="log-body" :style="{backgroundImage: 'url('+login_bg+')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}">
      <div class="log-container">
      <el-tabs type="border-card" @tab-click="tabChange" value="admin" style="width:400px" class="login-type-tab">
        <el-tab-pane v-if="system_mode !== 'group'" name="admin" label="管理员登录(shopexid)">
            <div class="log-img"></div>
            <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
              <h3 class="title"><a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a></h3>
              <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm1.account" name="account" auto-complete="off" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm1.checkPass" name="password" auto-complete="off" placeholder="密码"></el-input>
              </el-form-item>
              <el-form-item class="log-opr clearfix">
                <el-checkbox v-model="checked" checked class="remember f_l">记住密码</el-checkbox>
                <a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a>
              </el-form-item>
              <el-form-item style="width:100%">
                <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :disabled="submitDisabled">登录</el-button>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="system_mode === 'group'" name="localadmin" label="管理员登录(独立账号)">
            <div class="log-img"></div>
            <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
              <h3 class="title"><a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a></h3>
              <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm1.account" name="account" auto-complete="off" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm1.checkPass" name="password" auto-complete="off" placeholder="密码"></el-input>
              </el-form-item>
              <el-form-item class="log-opr clearfix">
                <el-checkbox v-model="checked" checked class="remember f_l">记住密码</el-checkbox>
                <a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a>
              </el-form-item>
              <el-form-item style="width:100%">
                <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :disabled="submitDisabled">登录</el-button>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane name="staff" label="员工账号登录">
            <div class="log-img"></div>
            <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
              <h3 class="title"></h3>
              <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm1.account" name="account" auto-complete="off" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm1.checkPass" name="password" auto-complete="off" placeholder="密码"></el-input>
              </el-form-item>
              <el-form-item v-if="system_is_saas == 'false'" class="log-opr clearfix title">
                忘记密码，请联系管理员后台重置
              </el-form-item>
              <el-form-item v-if="system_is_saas == 'true'" class="log-opr clearfix">
                <router-link to="/forget" class="forget-pwd">忘记密码</router-link>
              </el-form-item>
              <el-form-item style="width:100%">
                <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :disabled="submitDisabled">登录</el-button>
              </el-form-item>
            </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>

    </div>
    <div class="log-footer">
      <span>友情链接：</span>
      <a href="https://mp.weixin.qq.com/cgi-bin/loginpage?t=wxm2-login&lang=zh_CN" target="_blank">微信公众平台</a>
      <span>|</span>
      <a href="https://www.alipay.com/" target="_blank">支付宝</a>
      <span>|</span>
      <a href="http://e.qq.com/ads" target="_blank">腾讯社交广告</a>
    </div>
    <div class="beian">
      <template v-if="BEIAN">
        ICP证：<a href="http://www.beian.miit.gov.cn">{{BEIAN}}</a>
      </template>
    </div> -->

    <div class="flex-box log-box">
      <div class="login-lf">
        <img src="../../static/img/image/login_left_default.png">
      </div>
      <div class="login-rt">
        <div class="logo">
          <img src="../../static/img/image/login_logo_default@3x.png">
        </div>
        <div class="login-box">
          <el-tabs  @tab-click="tabChange" value="staff" style="width:450px" class="login-type-tab">
            <el-tab-pane name="staff" label="员工账号登录">
                <div class="log-img"></div>
                <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
                  <h3 class="title"></h3>
                  <el-form-item prop="account">
                    <img src="../../static/img/image/login_icon_phone_default.png" class="icon-input">
                    <el-input type="text"  v-model="ruleForm1.account" name="account" auto-complete="off" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                  <el-form-item prop="checkPass">
                    <img src="../../static/img/image/login_icon_password_default.png" class="icon-input">
                    <el-input type="password"  v-model="ruleForm1.checkPass" name="password" auto-complete="off" placeholder="密码"></el-input>
                  </el-form-item>
                  <el-form-item v-if="system_is_saas == 'false'" class="log-opr clearfix title">
                    忘记密码，请联系管理员后台重置
                  </el-form-item>
                  <el-form-item v-if="system_is_saas == 'true'" class="log-opr clearfix staff-margin">
                    <router-link to="/forget" class="forget-pwd">忘记密码</router-link>
                  </el-form-item>
                  <el-form-item style="width:100%">
                    <el-button type="primary" style="width:100%;height:50px;font-size: 17px;" @click.native.prevent="handleSubmit1" :disabled="submitDisabled">登录</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-if="system_mode !== 'group'" name="admin" label="管理员登录">
                <div class="log-img"></div>
                <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
                  <!-- <h3 class="title"><a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a></h3> -->
                  <h3 class="title"></h3>
                  <el-form-item prop="account">
                    <img src="../../static/img/image/login_icon_phone_default.png" class="icon-input">
                    <el-input type="text" v-model="ruleForm1.account" name="account" auto-complete="off" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                  <el-form-item prop="checkPass">
                    <img src="../../static/img/image/login_icon_password_default.png" class="icon-input">
                    <el-input type="password" v-model="ruleForm1.checkPass" name="password" auto-complete="off" placeholder="密码"></el-input>
                  </el-form-item>
                  <el-form-item class="log-opr clearfix">
                    <el-checkbox v-model="checked" checked class="remember f_l">记住密码</el-checkbox>
                    <!-- <p class="admin-p">
                      <a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a>
                      <span class="divid">|</span>
                      <a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a>
                    </p> -->
                  </el-form-item>
                  <el-form-item style="width:100%">
                    <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :disabled="submitDisabled">登录</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-if="system_mode === 'group'" name="localadmin" label="管理员登录(独立账号)">
                <div class="log-img"></div>
                <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
                  <h3 class="title"></h3>
                  <el-form-item prop="account">
                    <img src="../../static/img/image/login_icon_phone_default.png" class="icon-input">
                    <el-input type="text" v-model="ruleForm1.account" name="account" auto-complete="off" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                  <el-form-item prop="checkPass">
                    <img src="../../static/img/image/login_icon_password_default.png" class="icon-input">
                    <el-input type="password" v-model="ruleForm1.checkPass" name="password" auto-complete="off" placeholder="密码"></el-input>
                  </el-form-item>
                  <el-form-item class="log-opr clearfix">
                    <el-checkbox v-model="checked" checked class="remember f_l">记住密码</el-checkbox>
                     <!-- <p class="admin-p">
                      <a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a>
                      <span class="divid">|</span>
                      <a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a>
                    </p> -->
                    <!-- <a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a> -->
                  </el-form-item>
                  <el-form-item style="width:100%">
                    <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :disabled="submitDisabled">登录</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>

          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isMobile } from '../utils/validate'
  import fetch from '../utils/fetch'
  import { login, getAdminInfo } from '../api/login'
  import { installPermissionRoutes } from '../router'
  export default {
    data () {
      const validateEmail = (rule, value, callback) => {
        if (!isMobile(value)) {
          callback(new Error('请输入正确的合法手机号'))
        } else {
          callback()
        }
      }
      const validatePass = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error('密码不能小于6位'))
        } else {
          callback()
        }
      }
      return {
        brand: '',
        login_bg: '',
        logining: false,
        ruleForm1: {
          account: '',
          checkPass: '',
          loginType: 'staff'
        },
        rules1: {
          account: [
            { required: true, trigger: 'blur', validator: validateEmail }
          ],
          checkPass: [
            { required: true, trigger: 'blur', validator: validatePass }
          ]
        },
        checked: true,
        submitDisabled: false
      }
    },
    methods: {
      tabChange (e) {
        this.ruleForm1.loginType = e.name
        this.ruleForm1.account = ''
        this.ruleForm1.checkPass = ''
      },
      handleSubmit1 () {
        if (this.submitDisabled) return
        this.$refs.ruleForm1.validate(async valid => {
          if (!valid) return
          this.submitDisabled = true
          try {
            const params = { username: this.ruleForm1.account, password: this.ruleForm1.checkPass, logintype: this.ruleForm1.loginType }
            const response = await login(params)
            await this.$store.dispatch('setToken', response.data.data.token)
            const [permissions, info] = await Promise.all([
              fetch({ url: '/permission', method: 'get', notShowLoading: true }),
              getAdminInfo()
            ])
            const menus = permissions.data.data
            if (!Array.isArray(menus) || !menus.length) {
              this.$message({ message: '当前账号没有权限，请联系管理员', type: 'error', duration: 3000 })
              return
            }
            await this.$store.dispatch('setUser', info.data.data)
            await this.$store.dispatch('setLoginType', info.data.data.logintype)
            await this.$store.dispatch('setMenu', menus)
            installPermissionRoutes(menus)
            const url = this.path_prefixes ? (menus[0].url === '/' ? `/${this.path_prefixes}` : `${this.path_prefixes}${menus[0].url}`) : menus[0].url
            this.$message({ message: '登录成功', type: 'success', duration: 2000 })
            this.$router.replace({ path: url })
          } catch (error) {
            // The shared request layer displays the API error.
          } finally {
            this.submitDisabled = false
          }
        })
      }
    },
    mounted() {
      this.$store.dispatch('setLoginType', 'default')
      this.brand = require('../../static/img/'+this.companyBrandImg+'/logo.svg')
      this.login_bg = require('../../static/img/'+this.companyBrandImg+'/login_bg.jpg')
    }
  }
</script>

<style lang="scss" scoped>
  body {
    background: #eaeaea;
    height: 100%;
  }
  .out-box{
    height: 100%;
  }
  .flex-box{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    .el-input__inner{
      height: 50px !important;
    }
    .login-lf{
      width: 44%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .login-rt{
      width: 44%;
      text-align: center;
      margin-top: 8%;
      .logo{
        img{
          width: 220px;
        }
      }
      .login-box{
        margin-left: 28%;
        margin-top: 40px;
        .icon-input{
          position: absolute;
          left: 4px;
          z-index: 100;
          top: 16px;
          width: 24px;
          height: 24px;
        }
        .divid{
          position: absolute;
          right: 68px;
          color: #ccc;
        }
        .staff-margin{
          margin-bottom: 30px;
        }
      }

      .login-log-container{
        width: 450px;
      }

    }
  }
  .log-header {
    padding: 20px 0;
    background: #fff;
  }
  .brand {
    display: inline-block;
    width: 150px;
    vertical-align: middle;
  }
  .brand img {
    width: 100%;
    height: auto;
  }
  .log-welcome {
    display: inline-block;
    padding-left: 24px;
    margin-left: 24px;
    border-left: 1px solid #efefef;
    vertical-align: middle;
  }
  .log-body {
    padding: 118px 0;
    // background: url(/static/img/login_bg.jpg) no-repeat center center;
    background-size: cover;
  }
  .log-img {
    float: left;
    width: 360px;
    padding-top: 5px;
    padding-left: 50px;
  }
  .log-img img {
    width: 100%;
    height: auto;
  }
  .log-container {
    width: 900px;
    margin: 0 auto;
  }
  .log-container::after {
    display: table;
    clear: both;
    content: "";
  }
  .login-log-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02)*/
    // float: right;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    // width: 290px;
    padding: 0px 35px 15px 0px;
    background: #fff;
    //border: 1px solid #eaeaea;
    .title {
      margin: 0px auto 35px auto;
      text-align: center;
      color: #505458;
      position: relative;
      font-size: 18px;
    }
    .remember {
      // margin: 0px 0px 35px 0px;
      float: left;
    }
    .log-opr {
      margin-bottom: 10px;
    }
    .signup {
      color: #FEBB40;
      font-size: 14px;
      position: absolute;
      right: 0;
      // line-height: 27px;
      &:hover {
        text-decoration: underline;
      }
    }
    .forget-pwd {
      // float: right;
      position: absolute;
      right: 0px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .el-form-item {
    margin-bottom: 30px;
  }
  .log-footer {
    color: #999;
    text-align: center;
    padding: 30px 0 10px 0;
    a {
      color: #999;
      margin: 0 5px;
      &:hover {
        color: #ff5000;
      }
    }
  }
  // .login-type-tab {
  //   float: right;
  // }
  .beian {
    padding-bottom: 30px;
    text-align: center;
    font-size: 12px;
  }

  .admin-p{
     .forget-pwd {
      // float: right;
      position: absolute;
      right: 78px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
<style lang="scss">
  .log-body {
    .el-input {
    .el-input__inner {
      height: 38px;
    }
  }
  }
  .log-box{
    .el-tabs__item{
      font-size: 17px !important;
    }
     input:-webkit-autofill {
      box-shadow: 0 0 0 100px #fff inset;
      -webkit-text-fill-color: #000;
    }
    .el-button--primary{
      height: 50px;
      font-size: 18px;
      margin-top: 28px;
    }
    .el-input__inner{
        height: 50px !important;
        color: rgba(0, 0, 0, 0.55);
        padding: 0 40px;
        font-size: 16px;
        border: none;
        background: none;
        border-bottom: 1px solid #ccc;
        border-radius: 0;
    }
    a{
       color: #FEBB40 !important;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label{
      color: #000;
    }
  }


</style>



// WEBPACK FOOTER //
// login.vue?12eabb92